import Navigation from "./Navigation";
import Welcome from "./Welcome";
import Contact from "./Contact";

export const Components = {
	Navigation: Navigation,
	Welcome: Welcome,
	Contact: Contact
}
